// @flow
import ClubFinderResult from 'components/club/ClubFinderResult';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/club/ClubFinderResult';
import { fetchClubs } from 'actions/clubsActions';
import { setQuery, setPractices, activateDistance, deactivateDistance, reinitialiseSearch } from 'actions/filterOptionsActions';

export default connect(
  (state: StateType): StateProps => ({
    clubs: state.clubsState.clubs,
    status: state.clubsState.status,
    query: state.filterOptionsState.query,
    competitions: state.filterOptionsState.competitions,
    practices: state.filterOptionsState.practices,
    distance: state.filterOptionsState.distance,
    ligue: state.settingsState.ligue_id,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    activateDistance: () => dispatch(activateDistance()),
    deactivateDistance: () => dispatch(deactivateDistance()),
    fetchClubsPreview: () => dispatch(fetchClubs()),
    setQuery: (query: string) => dispatch(setQuery(query)),
    setPractices: (rugbyTypes: Array<string>) => dispatch(setPractices(rugbyTypes)),
    reinitialiseSearch: () => dispatch(reinitialiseSearch()),
  })
)(ClubFinderResult);
 